import user from '@user/store'
import ui from '@ui/store'

const store = {
  user,
  ui
}

export default store
